(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionStateHistoryDialogController', FrequentlyAskedQuestionStateHistoryDialogController);

    FrequentlyAskedQuestionStateHistoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FrequentlyAskedQuestionStateHistory', 'FrequentlyAskedQuestion', 'CustomUser'];

    function FrequentlyAskedQuestionStateHistoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FrequentlyAskedQuestionStateHistory, FrequentlyAskedQuestion, CustomUser) {
        var vm = this;

        vm.frequentlyAskedQuestionStateHistory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.frequentlyaskedquestions = FrequentlyAskedQuestion.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.frequentlyAskedQuestionStateHistory.id !== null) {
                FrequentlyAskedQuestionStateHistory.update(vm.frequentlyAskedQuestionStateHistory, onSaveSuccess, onSaveError);
            } else {
                FrequentlyAskedQuestionStateHistory.save(vm.frequentlyAskedQuestionStateHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:frequentlyAskedQuestionStateHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.stateSetTimestamp = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
